import React, { useRef, useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './styles/premium.css';

// Components
import SmoothScroll from './components/SmoothScroll/SmoothScroll';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
// import PageTransition from './components/PageTransition/PageTransition';

// Pages - Lazy Loaded for Performance
const Home = lazy(() => import('./pages/Home/Home'));
const Projects = lazy(() => import('./pages/Projects/Projects'));
const ProjectDetail = lazy(() => import('./pages/ProjectDetail/ProjectDetail'));
const About = lazy(() => import('./pages/About/About'));
const Contact = lazy(() => import('./pages/Contact/Contact'));
const Legal = lazy(() => import('./pages/Legal/Legal'));
const Privacy = lazy(() => import('./pages/Privacy/Privacy'));
const NotFound = lazy(() => import('./pages/NotFound/NotFound'));

function AppContent() {
  const location = useLocation();
  const transitionRef = useRef();
  const prevLocation = useRef(location.pathname);

  useEffect(() => {
    // Basic custom cursor script
    const cursor = document.querySelector('.cursor');
    const follower = document.querySelector('.cursor-follower');

    const moveCursor = (e) => {
      if (cursor && follower) {
        cursor.style.left = e.clientX + 'px';
        cursor.style.top = e.clientY + 'px';
        follower.style.left = e.clientX + 'px';
        follower.style.top = e.clientY + 'px';
      }
    };

    window.addEventListener('mousemove', moveCursor);
    return () => window.removeEventListener('mousemove', moveCursor);
  }, []);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Use an effect to trigger transition, but we'd need a more complex setup 
  // with a wrapper to delay the actual route render for a perfect transition.
  // For simplicity in this build, we just trigger the animation on route change.
  /*
  useEffect(() => {
    if (prevLocation.current !== location.pathname) {
      if (transitionRef.current) {
        transitionRef.current.playTransition();
      }
      prevLocation.current = location.pathname;
    }
  }, [location]);
  */

  return (
    <>
      <div className="cursor"></div>
      <div className="cursor-follower"></div>
      <Header />
      {/* <PageTransition ref={transitionRef} /> */}
      <main>
        <Suspense fallback={<div style={{ height: '100vh', width: '100vw', background: 'var(--bg)' }}></div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projets" element={<Projects />} />
            <Route path="/projets/:id" element={<ProjectDetail />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<Legal />} />
            <Route path="/politique-de-confidentialite" element={<Privacy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <SmoothScroll>
          <AppContent />
        </SmoothScroll>
      </Router>
    </HelmetProvider>
  );
}

export default App;
